/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

/* tslint:disable:max-classes-per-file */
// tslint:disable:max-classes-per-file
import { Action } from '@ngrx/store';

// send form to register user
export const RESET_USER = '[Registration] Reset User for Signup State';
export const SAVE_USER_FOR_SIGNUP = '[Registration] Save User for Signup';
export const LOAD_USER_FOR_SIGNUP = '[Registration] Load User for Signup';
export const USER_SIGNUP = '[Registration] User Signup';
export const USER_SIGNUP_FAIL = '[Registration] User Signup Fail';
export const USER_SIGNUP_SUCCESS = '[Registration] User Signup Success';
export const SET_USER_PLAN = '[Registration] Set User Plan';
export const UPDATE_USER = '[Registration] Update User';
export const UPDATE_USER_FAIL = '[Registration] Update User Fail';
export const UPDATE_USER_SUCCESS = '[Registration] Update User Success';
export const LOAD_USER = '[Registration] Load User';
export const LOAD_USER_SUCCESS = '[Registration] Load User Success';
export const LOAD_USER_FAIL = '[Registration] Load User Success';
export const CLAIM_ACCOUNT = '[Registration] Claim Account';
export const CLAIM_ACCOUNT_SUCCESS = '[Registration] Claim Account Success';
export const CLAIM_ACCOUNT_FAIL = '[Registration] Claim Account Success';

export class ResetUser implements Action {
  readonly type = RESET_USER;

  constructor(public payload: any = null) {}
}

export class SaveUserForSignup implements Action {
  readonly type = SAVE_USER_FOR_SIGNUP;

  constructor(public payload: any) {}
}

export class LoadUserForSignup implements Action {
  readonly type = LOAD_USER_FOR_SIGNUP;

  constructor(public payload: any = null) {}
}

export class UserSignup implements Action {
  readonly type = USER_SIGNUP;

  constructor(public payload: any) {}
}

export class UserSignupFail implements Action {
  readonly type = USER_SIGNUP_FAIL;

  constructor(public payload: any) {}
}

export class UserSignupSuccess implements Action {
  readonly type = USER_SIGNUP_SUCCESS;

  constructor(public payload: any) {}
}

export class SetUserPlan implements Action {
  readonly type = SET_USER_PLAN;

  constructor(public payload: any) {}
}

export class UpdateUser implements Action {
  readonly type = UPDATE_USER;

  constructor(public payload: any) {}
}

export class UpdateUserFail implements Action {
  readonly type = UPDATE_USER_FAIL;

  constructor(public payload: any) {}
}

export class UpdateUserSuccess implements Action {
  readonly type = UPDATE_USER_SUCCESS;

  constructor(public payload: any) {}
}

export class LoadUser implements Action {
  readonly type = LOAD_USER;

  constructor(public payload: any) {}
}

export class LoadUserFail implements Action {
  readonly type = LOAD_USER_FAIL;

  constructor(public payload: any) {}
}

export class LoadUserSuccess implements Action {
  readonly type = LOAD_USER_SUCCESS;

  constructor(public payload: any) {}
}

export class ClaimAccount implements Action {
  readonly type = CLAIM_ACCOUNT;

  constructor(public payload: any) {}
}

export class ClaimAccountFail implements Action {
  readonly type = CLAIM_ACCOUNT_FAIL;

  constructor(public payload: any) {}
}

export class ClaimAccountSuccess implements Action {
  readonly type = CLAIM_ACCOUNT_SUCCESS;

  constructor(public payload: any) {}
}

// action types
export type SignupAction =
  | ResetUser
  | LoadUserForSignup
  | SaveUserForSignup
  | UserSignup
  | UserSignupFail
  | UserSignupSuccess
  | SetUserPlan
  | UpdateUser
  | UpdateUserFail
  | UpdateUserSuccess
  | LoadUser
  | LoadUserFail
  | LoadUserSuccess
  | ClaimAccount
  | ClaimAccountFail
  | ClaimAccountSuccess;
